// функция получения результата таск из драматик
import {API_DRAMATIQ_TASK_RESULT} from "../service/api.endpoint";
import http from "../service/axiosConfig";

const GetTaskResult = async (requestId: string) => {
    const response: any = await http.get(API_DRAMATIQ_TASK_RESULT, {params: {requestId: requestId}});
    return response;
}

export default GetTaskResult;
